import { render, staticRenderFns } from "./KeyResultComments.vue?vue&type=template&id=c509c74e&"
import script from "./KeyResultComments.vue?vue&type=script&lang=js&"
export * from "./KeyResultComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports